'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosBody = function IoIosBody(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.3 6.3c0-2.5 1.2-3.8 3.7-3.8s3.8 1.3 3.8 3.8-1.3 3.7-3.8 3.7-3.7-1.2-3.7-3.7z m16.8 5c0.6 0 1 0.1 1.4 0.5s0.5 0.8 0.5 1.3-0.2 1-0.5 1.4-0.8 0.5-1.4 0.5h-7.6c-0.7 0.2-1.2 0.5-1.4 1.1-0.3 0.7-0.3 2.1 0 4.1l0.4 1.6v0.1l2.3 13.4c0.1 0.6 0 1-0.3 1.4s-0.6 0.7-1.2 0.8-1 0-1.4-0.3-0.7-0.7-0.8-1.3l-1.6-9.3v0l-0.2-0.7c0-0.4-0.2-0.8-0.4-1.2s-0.5-0.6-0.8-0.6h-0.2c-0.6 0-1.1 0.8-1.4 2.5v0l-1.6 9.3c-0.1 0.6-0.4 1-0.8 1.3s-0.9 0.4-1.4 0.3-0.9-0.4-1.2-0.8-0.4-0.8-0.3-1.4l2.3-13.4v-0.1l0.4-1.6c0.3-2 0.4-3.4 0-4.1-0.2-0.6-0.7-0.9-1.4-1.1h-7.6c-0.6 0-1-0.2-1.4-0.5s-0.5-0.8-0.5-1.4 0.2-0.9 0.5-1.3 0.8-0.5 1.4-0.5h26.2z' })
        )
    );
};

exports.default = IoIosBody;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-body.js
// module id = 2113
// module chunks = 0